<template>
<div>
   <template v-if="authenticated">
           <router-link :to="{ name: `${cartbtn.type}_til` , params:{url: cartbtn.url , id:cartbtn.id , type:cartbtn.type }}">
          <div class="add_cart_style_1">
              <i class="fas fa-shopping-basket"  aria-hidden="true"></i> Bestill nå
          </div>
          </router-link>
        </template>
        <template v-else>
           <router-link :to="{ name: `Login`}">
          <div class="add_cart_style_1">
             <i class="fas fa-shopping-basket"  aria-hidden="true"></i> Bestill nå
          </div>
          </router-link>
        </template>
</div>
     
         
         
      
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
   name:'block_cart',
   components:{
   },
   data(){
     return{
       refsModal: this.cartbtn
     }
   },
   props:['cartbtn'],
        computed:{
          ...mapGetters({
             authenticated:'auth/authenticated',
          })
        },
        methods:{
          ...mapActions({
            box_details:'box_details'
          }),
          // print_object(){
          //   this.box_details(this.cartbtn.id)
          // }
           
        }
}
</script>

<style lang="scss" scoped>
.add_cart_style_1 {
       cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    transition: 0.3s linear;
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: black;
    font-size: 14px;
    font-weight: 600;
    padding: 4px 11px;

}

.add_cart_style_1 a {
  /* color: black; */
  color: #0b1518;
}

.add_cart_style_1 {
  /* background-color: #f6c44b; */
  background-color: var(--active_color);
  border: 1px solid transparent;
}
.add_cart_style_1 i {
  color: #000;
  font-size: 15px;
  margin-right: 5px;
   transition: 0.3s linear;
}

.add_cart_style_1:hover {
  background-color: #000;
  color: var(--active_color);
  border: 1px solid var(--active_color);
}

.add_cart_style_1:hover i {
  color: var(--active_color);
}
</style>